import React, { useEffect, useRef, useState } from "react";
import Footer from "../Footer/footer";
import Header from "../Header/header";
import FAQSection from "../ClassIntroFAQ/classIntroFAQ";
// import NamazTimings from "../NamazTimings/namazTimings";
import { getFields, submitForm } from "./_request";
import { useLocation } from "react-router-dom";

export default function Taaruf() {
  const location = useLocation();
  const amnTaarufRef = useRef(null);
  const classTarauf = useRef(null);
  const classdarjat = useRef(null);
  // const MunasibatHighlights = useRef(null);
  useEffect(() => {
    const hashToRef = {
      "#amntaaruf": amnTaarufRef,
      "#classTarauf": classTarauf,
      "#classdarjat": classdarjat,
    };

    const targetRef = hashToRef[location.hash];
    if (targetRef?.current) {
      // Scroll to bottom instantly for bottom-to-top effect
      window.scrollTo({ top: document.body.scrollHeight, behavior: "auto" });
      setTimeout(() => {
        const rect = targetRef.current.getBoundingClientRect();
        const yOffset = -80; // Adjust for fixed header height (e.g., 80px)
        const viewportHeight = window.innerHeight;
        const elementHeight = rect.height;
        // Calculate scroll position to center the element
        const scrollY =
          targetRef.current.getBoundingClientRect().top +
          window.pageYOffset +
          yOffset -
          (viewportHeight - elementHeight) / 2;
        window.scrollTo({ top: scrollY, behavior: "smooth" });
      }, 100); // Delay to ensure DOM is rendered
    }
  }, [location]);
  return (
    <>
      <Header />
      {/* <NamazTimings /> */}
      <div className="bg-white min-h-screen tracking-[0.05rem] lg:mt-20 md:mt-18 mt-8 lg:px-20 md:px-10 px-6 text-black text-center font-nastaleeqRegular">
        <div className="bg-primaryBG rounded-3xl flex flex-col justify-center items-center lg:gap-y-8 md:gap-y-6 gap-y-4 py-10 px-5 md:px-10">
          {/* <h3 className="font-alMajeed text-3xl mt-2"> بِسمِ اللّہِ الرَّحْمٰن الرَّحِیْم </h3>
                    <h4 className="font-alMajeed text-3xl mt-2"> وَصَلَّی اللّٰہُ عَلَیْکَ یَا وَلِیَ الْعَصْرِ (عج) اَدْرِکْنَا </h4> */}
          <h1 className="font-nastaleeqKasheeda text-2xl md:text-3xl lg:text-4xl">
            امیرالمومنین حضرت علی علیہ السلام کا ارشاد گرامی ہے
          </h1>
          <h2 className="font-alMajeed text-xl md:text-2xl lg:text-3xl mt-2">
            مَنْ كُلِّفَ بِالاَدَبِ قَلَّتْ مَسَاوِیہِ وَ مَنْ قَلَّ اَدَبُہُ
            کَثُرَتْ مَسَاوِیہِ
          </h2>
          <p className="text-lg md:text-xl lg:text-2xl">
            (غرر الحکم جلد ۱ صفحہ ۴۰۴)
          </p>
          <p className="text-lg md:text-xl lg:text-2xl">
            جسے ٹھیک ٹھیک تربیت دی جائے گی وہ کم لڑکھڑائے گااور جس کی تربیت میں
            کسر رہ جائے گی وہ زیادہ ٹھوکریں کھائے گا۔
          </p>
        </div>
        <div
          ref={amnTaarufRef}
          id="amntaaruf"
          className="flex flex-col justify-center items-center gap-y-8 md:gap-y-6 py-10 rounded-lg lg:px-28 md:px-10 px-5"
        >
          <h1 className="font-nastaleeqKasheeda text-2xl md:text-3xl lg:text-4xl">
            ایسوسی ایشن آف مشتاقان نور
          </h1>
          <p className="text-lg md:text-xl lg:text-2xl">
            ایسوسی ایشن آف مشتاقانِ نور (امن)نے تعلیمات محمد و آل محمد علیہم
            السلام کی روشنی میں بچوں کی تربیت کے لئے کلاسز کا ایسا نظام روشناس
            کروایا ہے جو امام محمد باقر علیہ السلام کی سیرت سے متاثر ہو کر قائم
            کی گئی ہیں۔ امام محمد باقر علیہ السلام نے اسی طرح کی کلاسز کے ذریعے
            لوگوں میں اسلامی معارف عام کئے اور شاگردوں کی تربیت کے بعد انہیں دور
            دراز علاقوں میں بھیجاتاکہ وہ بھی درست عقائد لوگوں تک پہنچائیں ۔
          </p>
        </div>
        <div
          ref={classTarauf}
          id="classTarauf"
          className="bg-primaryBG rounded-3xl flex flex-col justify-center items-center gap-y-8 md:gap-y-6 py-20 lg:px-28 md:px-10 px-5 md:px-10"
        >
          <h1 className="font-nastaleeqKasheeda text-2xl md:text-3xl lg:text-4xl">
            تربیت اولاد کیوں ضروری ہے؟{" "}
          </h1>
          <p className="text-lg md:text-xl lg:text-2xl">
            ہمارے جگر گوشوں کے بگڑتے رویے، دین سے دوری اور والدین کی عزت میں
            کمی، سب امورِ تربیت سے غفلت کا نتیجہ ہیں۔ اگر ہم مولائے کائنات حضرت
            علی علیہ السلام کے قول پر غور کریں تو حقیقت واضح ہو جائے گی۔
            <br />
            انسانی فطرت میں اولاد کی محبت سب سے گہرا اور طاقتور جذبہ ہے۔ والدین
            اپنے بچوں کی تعلیم و تربیت پر بے پناہ وقت، محنت اور دولت خرچ کرتے
            ہیں، لیکن بعض اوقات غلط تربیت کی وجہ سے بچے بے راہ ہو جاتے ہیں۔
            ابتدا میں بچوں کی غلطیوں کو نظرانداز کیا جاتا ہے، لیکن جب بری عادتیں
            پختہ ہو جاتی ہیں تو انہیں بدلنا مشکل ہو جاتا ہے۔
            <br />
            اس لیے ضروری ہے کہ بچپن ہی سے ایسی تعلیم دی جائے جو ان کے ذہن کو
            مثبت سمت میں لے جائے اور غلط سوچ سے بچائے۔ تعلیم کا مقصد صرف دنیاوی
            کامیابی نہیں ہونا چاہیے، بلکہ دینی اور اخلاقی تربیت کو بھی اہمیت دی
            جانی چاہیے۔ بچوں کو ابتدا سے دین، خدا کی عظمت اور زندگی کے مقصد سے
            آگاہ کرنا ضروری ہے۔
          </p>
        </div>

        <div
          ref={classdarjat}
          id="classdarjat"
          className="flex flex-col items-center gap-y-8 md:gap-y-6 py-10 lg:px-28 md:px-10 px-5 rounded-lg"
        >
          <h1 className="font-nastaleeqKasheeda text-2xl md:text-3xl lg:text-4xl">
            کلاس کے مختلف درجات
          </h1>
          <div className="flex flex-col lg:flex-row md:flex-row lg:gap-x-48 md:gap-x-16 gap-y-10 items-center">
            <div className="order-3 lg:order-none text-center">
              <img
                src="IC.png"
                alt="IC Class"
                className="h-40 md:h-44 mx-auto"
              />
              <h2 className="text-xl md:text-2xl lg:text-3xl mt-10 font-nastaleeqKasheeda">
                آی سی کلاسز
              </h2>
              <p className="text-lg md:text-xl lg:text-xl mt-3 text-[#4C4C4C]">
                عمر ۱۲ سے۱۵ سال
              </p>
            </div>
            <div className="order-2 lg:order-none text-center">
              <img
                src="Pre-IC.png"
                alt="Pre-IC Class"
                className="h-40 md:h-44 mx-auto"
              />
              <h2 className="text-xl md:text-2xl lg:text-3xl mt-10 font-nastaleeqKasheeda">
                پری آی سی کلاسز
              </h2>
              <p className="text-lg md:text-xl lg:text-xl mt-3 text-[#4C4C4C]">
                عمر ۹ سے ۱۱ سال
              </p>
            </div>
            <div className="order-1 lg:order-none text-center">
              <img
                src="Quran-class.png"
                alt="Quran Class"
                className="h-40 md:h-44 mx-auto"
              />
              <h2 className="text-xl md:text-2xl lg:text-3xl mt-10 font-nastaleeqKasheeda">
                قرآن کلاسز
              </h2>
              <p className="text-lg md:text-xl lg:text-xl mt-3 text-[#4C4C4C]">
                عمر ۶ سے۸ سال
              </p>
            </div>
          </div>
        </div>

        <div className="flex flex-col items-center gap-y-8 md:gap-y-6 py-10 lg:px-28 md:px-10 px-5 rounded-lg">
          <h1 className="font-nastaleeqKasheeda text-2xl md:text-3xl lg:text-4xl">
            کلاس داخلہ فارم
          </h1>
          <p className="text-lg md:text-xl lg:text-2xl">
            کلاس میں شامل ہونے کے لیے مندرجہ ذیل داخلہ فارم مکمل کریں۔ انشاء
            اللہ ہم آپ سے جلد رابطہ کریں گے۔
          </p>
          <div className="w-full flex justify-center">
            <div className="w-full max-w-screen-lg">
              <ClassAdmissionForm />
            </div>
          </div>
        </div>
        <div className="container mx-auto py-10 px-4 md:px-10">
          <h1 className="text-center font-nastaleeqKasheeda text-2xl md:text-3xl lg:text-4xl">
            کلاس سے متعلق اکثر پوچھے گئے سوالات
          </h1>
          <FAQSection />
        </div>

        {/* <div className="bg-primaryBG rounded-3xl w-full flex flex-col justify-center items-center gap-y-8 py-10 my-10 lg:px-28 md:px-10 px-5">
                    <h1 className="font-nastaleeqKasheeda text-4xl">کلاس میں شمولیت کا فارم</h1>
                    <h2 className="text-2xl mt-2">براہ کرم داخلہ کی درخواست کے لیے اپنے بچے کی معلومات درج کریں۔</h2>
                    <form className="font-nastaleeqRegular lg:w-1/2 space-y-5">
                        <div className="flex gap-x-3 w-full px-3 justify-center">
                            <div className="w-1/2">
                                <input
                                    type="text"
                                    id="GuardianName"
                                    className="w-full border rounded-md py-2 px-3 placeholder:text-2xl focus:outline-none focus:ring focus:ring-primary"
                                    placeholder="سرپرست کا نام"
                                    dir="rtl"
                                />
                            </div>
                            <div className="w-1/2">
                                <input
                                    type="text"
                                    id="fullName"
                                    className="w-full border rounded-md py-2 px-3 placeholder:text-2xl focus:outline-none focus:ring focus:ring-primary"
                                    placeholder="پورا نام"
                                    dir="rtl"
                                />
                            </div>
                        </div>
                        <div className="flex w-full px-3 justify-center gap-x-3.5">
                            <div className="w-1/3">
                                <input
                                    type="email"
                                    id="email"
                                    className="w-full border rounded-md py-2 px-3 placeholder:text-2xl focus:outline-none focus:ring focus:ring-primary"
                                    placeholder="ای میل"
                                    dir="rtl"
                                />
                            </div>
                            <div className="w-1/3">
                                <input
                                    type="text"
                                    id="phone"
                                    className="w-full border rounded-md py-2 px-3 placeholder:text-2xl focus:outline-none focus:ring focus:ring-primary"
                                    placeholder="رابطہ نمبر"
                                    dir="rtl"
                                />
                            </div>
                            <div className="w-1/3">
                                <input
                                    type="text"
                                    id="age"
                                    className="w-full border rounded-md py-2 px-3 placeholder:text-2xl focus:outline-none focus:ring focus:ring-primary"
                                    placeholder="عمر"
                                    dir="rtl"
                                />
                            </div>
                        </div>
                        <div className="flex items-center w-full">
                            <input
                                type="text"
                                id="address"
                                className="w-full border rounded-md mx-3.5 py-2 px-3 placeholder:text-2xl focus:outline-none focus:ring focus:ring-primary"
                                placeholder="پتہ"
                                dir="rtl"
                            />
                        </div>
                        <div className="flex w-full gap-x-3 px-3 justify-center">
                            <div className="w-1/2">
                                <input
                                    type="text"
                                    id="city"
                                    className="w-full border rounded-md py-2 px-3 placeholder:text-2xl focus:outline-none focus:ring focus:ring-primary"
                                    placeholder="شہر"
                                    dir="rtl"
                                />
                            </div>
                            <div className="w-1/2">
                                <input
                                    type="text"
                                    id="country"
                                    className="w-full border rounded-md py-2 px-3 placeholder:text-2xl focus:outline-none focus:ring focus:ring-primary"
                                    placeholder="ملک"
                                    dir="rtl"
                                />
                            </div>
                        </div>
                        <div className="mt-6">
                            <button
                                type="submit"
                                className="bg-primary text-2xl text-white py-3 px-10 rounded-full hover:bg-secondary focus:outline-none focus:ring focus:ring-primary"
                            >
                                درخواست بھیجیں۔
                            </button>
                        </div>
                    </form>

                </div> */}
      </div>
      <Footer />
    </>
  );
}

function ClassAdmissionForm() {
  const [fields, setFields] = useState([]);
  const [form, setForm] = useState({});
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const [submitting, setSubmitting] = useState(false);

  useEffect(() => {
    setLoading(true);
    getFields()
      .then((data) => {
        // Convert fields object (with udf*_label keys) to array of {label, idx}
        const fieldsArr = [];
        if (data.fields && typeof data.fields === "object") {
          for (let i = 1; i <= 30; i++) {
            const label = data.fields[`udf${i}_label`];
            fieldsArr.push({ label: label ? label : "", idx: i });
          }
        }
        setFields(fieldsArr);
        // Initialize form state for only labeled fields, using udf* keys
        const initial = {};
        fieldsArr.forEach((f) => {
          if (f.label && f.label.trim() !== "") initial[`udf${f.idx}`] = "";
        });
        setForm(initial);
        setLoading(false);
      })
      .catch(() => {
        setError("فارم لوڈ کرنے میں مسئلہ ہے۔ براہ کرم بعد میں کوشش کریں۔");
        setLoading(false);
      });
  }, []);

  const handleChange = (e, key) => {
    setForm({ ...form, [key]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setSubmitting(true);
    try {
      await submitForm(form);
      // Show alert for success
      window.alert("درخواست کامیابی سے جمع ہو گئی ہے۔ ہم جلد رابطہ کریں گے۔");
      // Reset form
      setForm(Object.fromEntries(Object.keys(form).map((k) => [k, ""])));
    } catch (err) {
      // Show alert for error
      window.alert("درخواست جمع کرنے میں مسئلہ ہے۔ براہ کرم دوبارہ کوشش کریں۔");
    }
    setSubmitting(false);
  };

  if (loading) {
    return (
      <div className="flex justify-center items-center h-40">
        <div className="animate-spin rounded-full h-10 w-10 border-t-4 border-primary border-solid"></div>
      </div>
    );
  }

  if (error) return <div className="text-xl text-red-600 py-10">{error}</div>;

  return (
    <form
      className="font-nastaleeqRegular w-full space-y-5"
      onSubmit={handleSubmit}
    >
      {fields.map((f) =>
        f.label && f.label.trim() !== "" ? (
          <div className="w-full" key={f.idx}>
            <input
              type="text"
              className="w-3/4 border rounded-md py-2 px-7 placeholder:text-lg placeholder:md:text-xl placeholder:lg:text-2xl focus:outline-none focus:ring focus:ring-primary"
              placeholder={f.label}
              dir="rtl"
              value={form[`udf${f.idx}`] || ""}
              onChange={(e) => handleChange(e, `udf${f.idx}`)}
            />
          </div>
        ) : null,
      )}
      <div className="mt-6">
        <button
          type="submit"
          className="bg-primary text-lg md:text-xl lg:text-2xl text-white py-3 px-10 rounded-full hover:bg-secondary focus:outline-none focus:ring focus:ring-primary disabled:opacity-60"
          disabled={submitting}
        >
          {submitting ? (
            <div className="flex justify-center items-center h-40">
              <div className="animate-spin rounded-full h-10 w-10 border-t-4 border-white border-solid"></div>
            </div>
          ) : (
            "درخواست بھیجیں۔"
          )}
        </button>
      </div>
      {/* Removed success and error messages from UI */}
    </form>
  );
}
